import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "edit-fet",
  class: "d-flex flex-fill edit-page-40"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "edit-header" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "card-body overflow-auto" }
const _hoisted_6 = { id: "fet-draft" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_9 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("ID"),
  /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*")
], -1)
const _hoisted_11 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_12 = { class: "margin-top-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: 'customizable',
  class: "margin-left-3"
}, "Customizable", -1)
const _hoisted_14 = { class: "card-footer footer" }
const _hoisted_15 = { class: "float-right" }
const _hoisted_16 = { class: "loader-div-40" }
const _hoisted_17 = ["src"]

import { computed, onBeforeMount, ref } from "vue";
import { ElButton, ElInput } from "element-plus";
import { TYPE } from "vue-toastification";
import { currentRoute, router } from "@/core/router";
import { hasPermission } from "@/core/auth";
import {
  addPrivilege,
  editPrivilege,
  getPrivilege,
} from "@/privilege/services/privilege.service";
import { showAlert } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPrivileges',
  setup(__props) {

const { t } = i18n.global;

const pageName = ref(
  currentRoute.value.name === "createPrivileges"
    ? t("Common.Create")
    : t("Common.Edit")
);

const privilege = ref({
  name: "",
  description: "",
  privilegeId: "",
  customizable: false,
});

const isValid = computed(
  () => privilege.value.name !== "" && privilege.value.privilegeId
);

const id = ref("");

const pageLoading = ref(false);

const responseLoading = ref(false);

async function savePrivilege() {
  responseLoading.value = true;
  if (isValid.value && hasPermission("PRIVILEGES.PRIVILEGE.SAVE")) {
    if (id.value) {
      await editPrivilege(privilege.value).then((response) => {
        if (response) {
          showAlert(TYPE.SUCCESS, t("Privilege.PrivilegeUpdated"));
        }
      });
    } else {
      await addPrivilege(privilege.value).then((response) => {
        if (response) {
          showAlert(TYPE.SUCCESS, t("Privilege.PrivilegeCreated"));
        }
      });
    }
    await router.push("/privileges");
  } else if (hasPermission("PRIVILEGES.PRIVILEGE.SAVE")) {
    showAlert(TYPE.WARNING, t("Common.WarningMsg"));
  }
  responseLoading.value = false;
}

onBeforeMount(async () => {
  pageLoading.value = true;
  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getPrivilege(id.value).then((response) => {
      if (response) {
        privilege.value = response;
      }
    });
  }
  pageLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(pageName.value) + " " + _toDisplayString(_unref(t)("Privilege.Privileges")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Name")), 1),
              _hoisted_8
            ]),
            _createVNode(_unref(ElInput), {
              modelValue: privilege.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((privilege.value.name) = $event)),
              placeholder: _unref(t)('Common.Name')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_unref(ElInput), {
              modelValue: privilege.value.privilegeId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((privilege.value.privilegeId) = $event)),
              placeholder: "ID"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Description")), 1),
            _createVNode(_unref(ElInput), {
              modelValue: privilege.value.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((privilege.value.description) = $event)),
              rows: 3,
              autosize: { minRows: 3, maxRows: 6 },
              type: "textarea",
              placeholder: _unref(t)('Common.Description')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: 'customizable',
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((privilege.value.customizable) = $event))
            }, null, 512), [
              [_vModelCheckbox, privilege.value.customizable]
            ]),
            _hoisted_13
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/privileges')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Back")), 1)
            ]),
            _: 1
          }),
          (_unref(hasPermission)('PRIVILEGES.PRIVILEGE.SAVE'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "btn-oneTeg2",
                onClick: savePrivilege
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !pageLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_16, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_17)
    ], 512), [
      [_vShow, responseLoading.value || pageLoading.value]
    ])
  ]))
}
}

})